import { computed, ref, Ref } from 'vue'
import { ShiftPreset } from '../models/shiftPreset'

export type ShiftPresetDetailDialogState = {
    visible: boolean
    shiftPreset: ShiftPreset | null
}

const state: Ref<ShiftPresetDetailDialogState> = ref({
    visible: false,
    shiftPreset: null,
})

export function useShiftPresetDetailDialog() {
    const show = (shiftPreset: ShiftPreset) => {
        state.value = {
            visible: true,
            shiftPreset,
        }
    }

    const hide = () => {
        state.value = {
            visible: false,
            shiftPreset: null,
        }
    }

    const isShown = computed(() => state.value.visible)
    const shiftPreset = computed(() => state.value.shiftPreset)

    return {
        show,
        hide,
        isShown,
        shiftPreset,
    }
}